export interface IValueChange {
    ChangeDate: string; // "\/Date(1477267200000)\/",
    ChangeDateStr: string;
    FieldName: number;
    FieldNamestr: string;
    OldValue: string;
    OldValueStr: string;
    NewValue: string;
    NewValueStr: string;
}

export class ValueChange implements IValueChange {
    public ChangeDate: string;
    public ChangeDateStr: string;
    public FieldName: number;
    public FieldNamestr: string;
    public OldValue: string;
    public OldValueStr: string;
    public NewValue: string;
    public NewValueStr: string;
    constructor(
        valueChangeObject: any,
    ) {
        this.ChangeDate = valueChangeObject.changeDate;
        this.ChangeDateStr = valueChangeObject.changeDateStr;
        this.FieldName = valueChangeObject.fieldName;
        this.FieldNamestr = valueChangeObject.fieldNamestr;
        this.OldValue = valueChangeObject.oldValue;
        this.OldValueStr = valueChangeObject.oldValueStr;
        this.NewValue = valueChangeObject.newValue;
        this.NewValueStr = valueChangeObject.newValueStr;
    }
}
